<template>
  <div class="product-card-container">
    <div class="media">
      <img :src="displayImageUrl" @error="loadPlaceholder" :class="{placeholder}"/>
      <div class="mask" />
    </div>
    <div class="detail">
      <span class="product-name">{{ productName }}</span>
      <span>{{ product.size }}</span>
      <span>市场价：¥{{ product.price_market }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-card",
  props: {
    product: { type: Object, default: () => {} }
  },
  data() {
    return {
      placeholder: false,
      displayImageUrl: this.product.image_url,
    }
  },
  computed: {
    productName() {
      if (this.product) {
        return this.product.name_ch;
      }
      return '';
    }
  },
  methods: {
    loadPlaceholder () {
      this.placeholder = true;
      this.displayImageUrl = require("@/assets/img/placeholder.jpg");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/material-kit/_variables.scss";
.product-card-container {
  overflow: hidden;
  transition: all 0.3s;
  border-radius: 3px;
  box-shadow: $light-shadow;
  margin: 1rem;

  &:hover {
    cursor: pointer;
    transform: translateY(-3px);
    box-shadow: $heavy-shadow;
  }

  .media {
    height: 10rem;
    position: relative;
    display: flex;
    justify-content: center;

    img {
      height: 100%;
      width: auto;
    }
    .mask {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img.placeholder {
      width: 100%;
      object-fit: cover;
    }
  }

  .detail {
    height: 6rem;
    padding: 0.5rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    .product-name {
      width: 100%;
      font-weight: 500;
    }
  }
}
</style>
